var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('base-table',{ref:"table",attrs:{"url":"/routerWan/find","toolbar":_vm.toolbar,"columns":_vm.columns,"border":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }